import React, { useRef } from 'react';
import {
  Redirect, Route, Switch, useLocation,
} from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { useAuth } from 'shared/hooks';
import { loginPath, resetPath } from 'shared/routes/auth';
import Login from './Login';
import ResetPassword from './ResetPassword';

function AuthRedirect() {
  const { isLoggedIn } = useAuth();
  const { pathname, search } = useLocation();
  const inAuth = pathname.startsWith('/auth');
  const from = useRef(inAuth ? '/' : `${pathname}${search}`);

  if (isLoggedIn && inAuth) {
    return <Redirect to={from.current} />;
  }

  if (!isLoggedIn && !inAuth) {
    from.current = `${pathname}${search}`;
    return <Redirect to="/auth" />;
  }

  return null;
}

// Auth provides routes for authenticating the user.
export default function Auth() {
  const { isLoggedIn } = useAuth();
  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        marginTop: '33vh',
        marginX: (theme) => theme.spacing(4),
        display: isLoggedIn ? 'none' : 'flex',
      }}
    >
      <Route
        component={AuthRedirect}
        path="/"
      />
      <Switch>
        <Route
          component={Login}
          exact
          path={loginPath}
        />
        <Route
          component={ResetPassword}
          exact
          path={resetPath}
        />
      </Switch>
    </Grid>
  );
}
